import { render, staticRenderFns } from "./WorkTaskMeasureItem.vue?vue&type=template&id=3741be4f"
import script from "./WorkTaskMeasureItem.vue?vue&type=script&lang=ts"
export * from "./WorkTaskMeasureItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports